<template>
  <div class="other-documentation">
    <h1 id="partner-api-call-limits">Partner API Call Limits</h1>
    <p>
      To ensure service stability and fairness, we apply rate limits to API calls. The table below outlines these call
      rate limits, which we may adjust based on operational requirements.
      <br>
      The applicable policy is determined based on your integration type, user scale, and observed traffic behavior.
    </p>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">
            Integration Type
          </th>
          <th class="text-left">
            Limit Basis
          </th>
          <th class="text-left">
            Value
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="limit in rateLimits" :key="limit.integrationType">
          <td>{{ limit.integrationType }}</td>
          <td>{{ limit.limitBasis }}</td>
          <td>{{ limit.value }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <p>
      Exceeding the rate limits, which involves making a large number of requests within a short period of time, or
      engaging in other abnormal or high-risk behaviors, will result in the service returning HTTP status code 429 (Too
      Many Requests). Developers are advised to implement a reasonable request control mechanism.
      <br>
      For further information about the rate limiting policy or to request an evaluation, please contact our technical
      support team.
      <br>
      <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
    </p>
  </div>
</template>

<style scoped>
tr:hover {
  background-color: transparent !important;
}
</style>

<script>
export default {
  data() {
    return {
      supportEmail: "developer.support@assaabloy.com",
      rateLimits: [
        {
          integrationType: 'Cloud',
          limitBasis: 'per API Key',
          value: '500 req / min'
        },
        {
          integrationType: 'Client-Side',
          limitBasis: 'per IP',
          value: '50 req / min'
        }
      ]
    }
  }
}
</script>